const actions = {
  async updateInfo({ getters, dispatch, commit }, data) {
    const res = await dispatch('api/nav/adminUpdateSpaceInfo', data);

    if (res.success) {
      dispatch('updateCurrentArea', { data: { ...getters.getCurrentAreaData, banner: res.success?.banner || ''}})
      commit('setCurrentAreaInfo', data);
    } else {
      dispatch('popups/show/error/custom', 'adding extra info to this Space', {root: true})
    }

    return res
  },
  async uploadInfoImage({ dispatch }, file) {
    let res = await dispatch('api/genericHandler', ['media/uploadImage', "Error uploading background", [file, 'spaceBannerImage']]);
    return res?.success || '';
  },
};

export default {
  actions
};
